module.exports = __webpack_public_path__ + "img/face22.2de3b3a6.gif";